import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Skeleton,
  Upload,
} from "antd";
import "./style.css";
import { localhost } from "../../../../server_url";
import { UploadOutlined, CopyOutlined } from "@ant-design/icons";
import { CopyToClipboard } from "react-copy-to-clipboard";

const ViewRecruitmentRequirement = ({
  dataDetail,
  form,
  isModalViewRecruitment,
  onCancelViewRecruitment,
  onFinishEdit,
  isDisableForm,
  setIsDisableForm,
  handleChangeUpload,
  uploadFileRec,
  loading,
}) => {
  if (dataDetail == undefined || dataDetail.length == 0) {
    return null;
  }

  useEffect(() => {
    if (dataDetail != undefined && dataDetail.length != 0) {
      form.setFieldsValue({
        ticket_code: dataDetail.results.ticket_code,
        link_cv: localhost + "/cv/" + dataDetail.results.link_cv,
        title: dataDetail.results.title,
        quantity: dataDetail.results.quantity,
        department_recruited_name: dataDetail.results.department_recruited_name,
        work_location: dataDetail.results.work_location,
        duedate: dataDetail.results.duedate,
        user_update_name: dataDetail.results.user_update_name,
        reason_recr_id:
          dataDetail.results.reason_recr_id !== null
            ? parseInt(dataDetail.results.reason_recr_id)
            : undefined,
        user_new_quits: dataDetail.results.user_new_quits,
        language_skill: dataDetail.results.language_skill,
        computer_skill: dataDetail.results.computer_skill,
        other_skill: dataDetail.results.other_skill,
        note: dataDetail.results.note,
      });
    }
  }, [isModalViewRecruitment, dataDetail]);

  //   useEffect(() => {
  //       setIsDisableForm(true);

  // }, [loading]);

  const ComponentUploadFile = ({}) => {
    return (
      <Upload
        onChange={handleChangeUpload}
        fileList={uploadFileRec}
        className=""
        maxCount={1}
        beforeUpload={(file) => {
          form.setFieldsValue({
            name_file_recr: file.name,
          });
          return false;
        }}
        showUploadList={false}
        disabled={isDisableForm}
      >
        <span style={{ cursor: "pointer" }}>
          <UploadOutlined /> Tải lên
        </span>
      </Upload>
    );
  };

  return (
    <Modal
      title={
        <>
          Chi tiết yêu cầu tuyển dụng &nbsp;
          {dataDetail.length != 0 && (
            <a
              style={{
                backgroundColor: dataDetail.results.color,
                color: "#ffffff",
                padding: "3px 5px 3px 5px",
                borderRadius: "5px",
              }}
            >
              {dataDetail.results.ticket_status_name}
            </a>
          )}
        </>
      }
      open={isModalViewRecruitment}
      //   onOk={handleOkAddRecruitmentRequirements}
      onCancel={() => {
        onCancelViewRecruitment();
        setIsDisableForm(true);
      }}
      width={800}
      footer={false}
      className="modalView"
    >
      {/* <Skeleton loading={loading} active={true} avatar={false}> */}
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={(values) => {
          onFinishEdit(values);
          setIsDisableForm(true);
          form.setFieldsValue({
            name_file_recr: "",
          });
        }}
        // onFinishFailed={onFinishFailed}
        // validateMessages={validateMessages}
        // loading={loading}
        initialValues={{
          remember: true,
        }}
      >
        <Row className="modal-recruitment-requirement">
          <Col span={11}>
            <Form.Item label="Mã yêu cầu" name="ticket_code">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item label="Link CV" name="link_cv">
              <Input
                className="addAfInput"
                disabled
                addonAfter={
                  <CopyToClipboard
                    text={localhost + "/cv/" + dataDetail.results.link_cv}
                  >
                    <CopyOutlined title="Copy" />
                  </CopyToClipboard>
                }
              />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item label="Tiêu đề yêu cầu" name="title">
              <Input.TextArea
                autoSize={{
                  minRows: 2,
                  // maxRows: 5,
                }}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item label="Số lượng" name="quantity">
              <Input disabled={isDisableForm} />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              label="Bộ phận tuyển dụng"
              name="department_recruited_name"
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item label="Địa điểm làm việc" name="work_location">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item label="Ngày hết hạn" name="duedate">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item label="Người cập nhật" name="user_update_name">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item label="Lý do tuyển" name="reason_recr_id">
              <Select placeholder="Chọn lý do tuyển" disabled={isDisableForm}>
                {dataDetail.list_reason_recruitment.map((item) => (
                  <Select.Option
                    key={item.id}
                    value={item.id}
                    title={item.description}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item label="Tuyển thay thế Nhân viên" name="user_new_quits">
              <Input disabled={isDisableForm} />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item label="Trình độ ngoại ngữ" name="language_skill">
              <Input disabled={isDisableForm} />
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item label="Trình độ tin học" name="computer_skill">
              <Input disabled={isDisableForm} />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item label="Kỹ năng khác" name="other_skill">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={11} offset={2}>
            <Form.Item label="Ghi chú" name="note">
              <Input.TextArea
                autoSize={{
                  minRows: 2,
                }}
                disabled={isDisableForm}
              />
            </Form.Item>
          </Col>

          <Col span={11}>
            <Form.Item
              label={
                <>
                  File tuyển dụng: &nbsp;{" "}
                  {dataDetail && (
                    <a
                      href={
                        localhost +
                        "/" +
                        dataDetail.results.path_file_recr +
                        dataDetail.results.name_file_recr
                      }
                    >
                      {dataDetail.results.name_file_recr}
                    </a>
                  )}
                </>
              }
              name="name_file_recr"
            >
              <Input
                addonAfter={<ComponentUploadFile />}
                disabled={isDisableForm}
              ></Input>
            </Form.Item>
          </Col>
          {/* <Col span={11}>
              <Form.Item label="Mô tả công việc">
                <Input.TextArea
                  showCount
                  maxLength={100}
                  placeholder="Công việc cụ thể sẽ làm gì"
                  autoSize={{
                    minRows: 3,
                    maxRows: 5,
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={2}></Col>
            <Col span={11}>
              <Form.Item label="Yêu cầu chuyên môn">
                <Input.TextArea
                  showCount
                  maxLength={100}
                  placeholder="Yêu cần nhân sự như thế nào, kinh nghiệm, kỹ năng cần có..."
                  autoSize={{
                    minRows: 3,
                    maxRows: 5,
                  }}
                />
              </Form.Item>
            </Col> */}

          <Col span={21} style={{ textAlign: "right" }}>
            {isDisableForm ? (
              <Button type="primary" onClick={() => setIsDisableForm(false)}>
                Chỉnh sửa
              </Button>
            ) : (
              <Form.Item style={{ display: "inline-block" }}>
                <Button type="success" htmlType="submit">
                  Lưu
                </Button>
              </Form.Item>
            )}
          </Col>
          <Col span={3} style={{ textAlign: "right" }}>
            <Form.Item style={{ display: "inline-block" }}>
              <Button
                onClick={() => {
                  onCancelViewRecruitment();
                  setIsDisableForm(true);
                }}
              >
                Thoát
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      {/* </Skeleton> */}
    </Modal>
  );
};

export default ViewRecruitmentRequirement;
